<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Transacciones</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Home</a></li>
        <li class="breadcrumb-item">Cuentas</li>
        <li class="breadcrumb-item active">Transacciones</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <!-- <h6>Categoría</h6> -->
        <button
          type="button"
          class="btn btn-theme"
          @click="openModal('register', '')">
          Nueva
        </button>
        <button
          type="button"
          class="btn btn-theme"
          @click="openModal('accounts', '')"
        >
          Transaccion entre cuentas
        </button>
      </div>
      <div class="card-body">

        <!-- busqueda -->
        <div class="form-group row">
          <div class="col-md-6">
            <div class="input-group">
              <select v-model="critery" class="form-control col-md-6">
                <option value="description">Descripción</option>
                <option value="account">Cuenta</option>
                <option value="employee">Empleado</option>
              </select>
              <input v-model="search" type="text" class="form-control" placeholder="Ingrese el texto a buscar" @keyup="fetchData(1,search,critery, transactionState)">
              <button type="submit" class="btn btn-theme" @click="fetchData(1,search,critery, transactionState)"><i class="icon-fa icon-fa-search"/> search</button>
            </div>
            <br>
            <div class="custom-control custom-checkbox mb-3">
              <input
                id="customControlValidation1"
                v-model="transactionState"
                type="checkbox"
                class="custom-control-input"
                required
                @change="fetchData(1, search, critery, transactionState)"
              >
              <label v-if="transactionState === false" class="custom-control-label" for="customControlValidation1">
                Mostrar las transacciones anuladas
              </label>
              <label v-else class="custom-control-label" for="customControlValidation1">
                Mostrar las transacciones activas
              </label>
              <div class="invalid-feedback">Example invalid feedback text</div>
            </div>
          </div>
        </div>

        <!-- tabla -->
        <table class="table table-responsive">
          <thead>
            <tr>
              <th>No.</th>
              <th>Descripción</th>
              <th>Documento de banco</th>
              <th>Foto del comprobante</th>
              <th>Cantidad</th>
              <th>Cuenta</th>
              <th>Empleado</th>
              <th>tipo de transacción</th>
              <th>Forma de pago</th>
              <th>Estado</th>
              <th>Fecha de registro</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="transaction in transactionsArray" :key="transaction.id">
              <td v-text="'Transacción' + ' ' + transaction.document_number"/>
              <!-- <td v-text="transaction.id"/> -->
              <td v-text="transaction.description"/>
              <td v-if="transaction.document_number_bank==null">Sin documento de banco</td>
              <td v-else v-text="transaction.document_number_bank"/>
              <td>
                <p v-if="transaction.photo=='transaction.png'">No tiene comprobante</p>
                <button v-tooltip.top-center="'Ver foto de comprobante'" v-else class="btn btn-info btn-block" @click="openModal('photo', transaction.photo)"><i class="icon-fa icon-fa-eye"/></button>
                <!-- <img :src="'/transactions/'+transaction.photo" class="imgRedondo" > -->
              </td>
              <td v-text="formatQuetzales3(transaction.amount)"/>
              <td v-text="transaction.account.name"/>
              <td v-text="transaction.employee.person.name"/>
              <td>
                <span v-if="transaction.type_transaction==1" class="btn btn-primary btn-sm">Depósito</span>
                <span v-else class="btn btn-warning btn-sm">Retiro</span>
              </td>
              <td v-if="transaction.payments" v-text="transaction.payments.name"/>
              <td v-else>Depósito inicial</td>
              <td>
                <span v-if="transaction.state==1||transaction.state==2" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Anulado</span>
              </td>
              <td v-text="transaction.created_at"/>
              <td>
                <template>
                  <div>
                    <button v-tooltip.top-center="'Anular transacción'" v-if="transaction.state==1" class="btn btn-danger" @click="openModal('cancel', transaction)"><i class="icon-fa icon-fa-ban"/></button>
                    <a/>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>

        <!--Paginación de tabla-->
        <div class="card">
          <div class="card-body">
            <ul class="pagination pagination-primary m-b-0">
              <li v-if="pagination.current_page > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search, critery, transactionState)"><i class="icon-fa icon-fa-angle-left"/></a>
              </li>
              <li v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(page, search, critery, transactionState)" v-text="page"/>
              </li>
              <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search, critery, transactionState)"><i class="icon-fa icon-fa-angle-right"/></a>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <!-- MODALES -->
      <sweet-modal
        ref="modal_transact"
        :title="modalTitle"
        hide-close-button
        blocking
      >
        <!-- START FORM -->
        <div class="card-body">
          <!-- Descripcion -->
          <div class="form-group">
            <label>Descripción</label>
            <textarea
              :class="{ 'is-invalid': $v.description.$error }"
              v-model.trim="description"
              class="form-control"
              @textarea="$v.description.$touch()"/>
            <div v-if="$v.description.$error">
              <span v-if="!$v.description.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <!-- numero de documento -->
          <div class="form-group">
            <label>Numero de documento de banco</label>
            <input
              :class="{ 'is-invalid': $v.document_number.$error }"
              v-model.trim="document_number"
              class="form-control"
              @input="$v.document_number.$touch()">
            <div v-if="$v.document_number.$error">
              <span v-if="!$v.document_number.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <!-- Account -->
          <div class="form-group">
            <label>Cuenta</label>
            <div class="form-inline">
              <multiselect
                v-model="idaccount"
                :options="accountArray"
                :close-on-select="true"
                :clear-on-select="false"
                :show-labels="false"
                :loading="isLoadingAccounts"
                style="width: 100%"
                label="name"
                track-by="id"
                placeholder="Buscar Cuenta..."
                @input="llamarAmount"
                @search-change="selectAccount"
              />
            </div>
          </div>
          <!-- amount -->
          <div class="form-group">
            <label>Cantidad actual</label>
            <input
              :class="{ 'is-invalid': $v.amount.$error }"
              :on-change="convercionesMoney"
              v-model.trim="amount"
              class="form-control"
              disabled
              @input="$v.amount.$touch()"
            >

            <div v-if="$v.amount.$error">
              <span v-if="!$v.amount.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <!-- type payment -->
          <div class="form-group">
            <label>Forma de pago</label>
            <select
              v-model.trim="payment"
              class="form-control"
              @input="$v.payment.$touch()"
            >
              <option v-for="payment in paymentsArray" :key="payment.id" :value="payment.id" v-text="payment.name"/>
            </select>
            <div v-if="$v.payment.$error">
              <span v-if="!$v.payment.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <!-- tipo de transaccion  -->
          <div class="form-group">
            <div class="form-check form-check-inline">
              <input
                id="inlineRadio1"
                v-model.trim="typeTransaction"
                class="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                value="1"
                @input="$v.typeTransaction.$touch()"
              >
              <label class="form-check-label" for="inlineRadio1">Deposito</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                id="inlineRadio2"
                v-model.trim="typeTransaction"
                class="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                value="0"
                @input="$v.typeTransaction.$touch()"
              >
              <label class="form-check-label" for="inlineRadio2">Retiro</label>
              <br>
              <div v-if="$v.typeTransaction.$error" class="col-md-12 error">
                <span v-if="!$v.typeTransaction.required" class="help-block help-block-error">
                  El campo es requerido
                </span>
              </div>
            </div>
          </div>
          <!-- amount transaction -->
          <div class="form-group">
            <label>Cantidad de transacción</label>
            <masked-input
              v-model="amountTransactionMoney"
              :guide="false"
              :mask="mask_quetzal"
              :disabled="amountTransactionBool"
              :class="{ 'is-invalid': $v.amountTransaction.$error }"
              :on-change="convertTrans()"
              type="text"
              class="form-control"
              @input="$v.amountTransaction.$touch()"
            />
            <div v-if="$v.amountTransaction.$error">
              <span v-if="!$v.amountTransaction.required" class="help-block help-block-error">
                El campo es requerido
              </span>
              <span v-else-if="!$v.amountTransaction.minValue" class="help-block help-block-error">
                El deposito o retiro no puede ser negativo.
              </span>
              <span v-else-if="typeTransaction=='1'" class="help-block help-block-error">
                Seleccione deposito o retiro
              </span>
              <span v-else class="help-block help-block-error">
                El maximo de retiro es de {{ formatQuetzales2($v.amountTransaction.$params.maxValue.max) }}.
              </span>
            </div>
          </div>

          <!-- photo -->
          <div class="form-group">
            <label>Imagen del comprobante</label>
            <div class="class-md-9">
              <input
                id="image"
                type="file"
                class="form-control"
                name="image"
                accept="image/*"
                @change="getImage"
              >
            </div>
          </div>
        </div>
        <!-- END FORM -->
        <button
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="closeModal()">
          Cancelar
        </button>
        <button
          v-if="typeAction == 1"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button" data-style="expand-right"
          @click="saveTransact()">
          Guardar
        </button>
      </sweet-modal>
      <sweet-modal
        ref="activate_modal"
        icon="info"
        hide-close-button
        blocking
      >
        {{ modalTitleActivate }}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.activate_modal.close()"
        >
          No
        </button>
        <button
          v-if="typeAction == 2"
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="cancelTransact()"
        >
          Si
        </button>
      </sweet-modal>
      <!-- entre cuentas -->
      <sweet-modal
        ref="accountsModal"
        :title="modalTitle"
        hide-close-button
        blocking
      >
        <div class="card-body">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Cuenta de retiro</label>
              <multiselect
                v-model="accountOut"
                :options="accountArray"
                :close-on-select="true"
                :clear-on-select="false"
                :show-labels="false"
                :loading="isLoadingAccounts"
                style="width: 100%"
                label="name"
                track-by="id"
                placeholder="Buscar Cuenta..."
                @input="llamarAmountOut"
                @search-change="selectAccount"
              />
              <div v-if="$v.accountOut.$error">
                <span v-if="!$v.accountOut.required" class="error">
                  El campo es requerido
                </span>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label>Cuenta a depositar</label>
              <multiselect
                v-model="accountIn"
                :options="accountArray"
                :close-on-select="true"
                :clear-on-select="false"
                :show-labels="false"
                :loading="isLoadingAccounts"
                style="width: 100%"
                label="name"
                track-by="id"
                placeholder="Buscar Cuenta..."
                @input="llamarAmountIn"
                @search-change="selectAccount"
              />
              <div v-if="$v.accountIn.$error">
                <span v-if="!$v.accountIn.required" class="error">
                  El campo es requerido
                </span>
                <span v-else class="error">
                  La cuenta de depósito no puede ser la misma que la de retiro
                </span>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Cantidad disponible</label>
              <input
                v-model.trim="amountOut"
                class="form-control"
                disabled
              >
            </div>
            <div class="form-group col-md-6">
              <label>Cantidad disponible</label>
              <input
                v-model.trim="amountIn"
                class="form-control"
                disabled
              >
            </div>
          </div>
          <div class="form-row">
            <label>Cantidad de transacción</label>
            <masked-input
              v-model="amountAccountTransact"
              :class="{ 'is-invalid': $v.amountAccountTransactNumber.$error }"
              :guide="false"
              :disabled="amountAccountTransactBool"
              :mask="mask_quetzal"
              :on-change="convertamountTransact()"
              type="text"
              class="form-control"
              @input="$v.amountAccountTransactNumber.$touch()"
            />
            <div v-if="$v.amountAccountTransactNumber.$error">
              <span v-if="!$v.amountAccountTransactNumber.required" class="help-block help-block-error">
                El campo es requerido
              </span>
              <span v-else-if="!$v.amountAccountTransactNumber.minValue" class="help-block help-block-error">
                El retiro no puede ser negativo.
              </span>
              <span v-else-if="!$v.amountAccountTransactNumber.maxValue" class="help-block help-block-error">
                El máximo de retiro es de {{ formatQuetzales2($v.amountAccountTransactNumber.$params.maxValue.max) }}
              </span>
              <!-- <span v-else-if="!$v.amountOut.sameAsNothing" class="help-block help-block-error">
                Seleccione las cuentas por favor.
              </span> -->
            </div>
          </div>
        </div>
        <button
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="closeModal()"
        >
          Cancelar
        </button>
        <button
          slot="button"
          type="button"
          class="btn btn-primary ladda-button" data-style="expand-right"
          @click="saveTransactAccounts()">
          Guardar
        </button>
      </sweet-modal>
      <sweet-modal
        ref="photoModal"
        modal-theme="dark"
        overlay-theme="dark"
      >
        <br><br>
        <img :src="photoTrans" class="imgRedondo" >
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import { required, maxValue, minValue, not, sameAs } from 'vuelidate/lib/validators'
import ladda from 'ladda'
import Multiselect from 'vue-multiselect'
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  components: {
    SweetModal,
    SweetModalTab,
    Multiselect,
    'masked-input': MaskedInput
  },
  data () {
    return {
      // vuelidatexd: this.$v.amountAccountTransact.error,
      nothing: '',
      modalTitle: '',
      description: '',
      id: 0,
      amount: '0',
      document_number: '',
      idemployee: 0,
      employeeArray: [],
      idaccount: null,
      accountArray: [],
      transactionsArray: [],
      typeAction: 1,
      modalTitleActivate: '',
      typeTransaction: '',
      amountTransaction: 0,
      amountTransactionBool: true,
      amountAccount: 0,
      name: '',
      photo: '',
      photoTrans: '',
      payment: '',
      paymentsArray: [],
      // variables para convertir dinero
      amountMoney: 0,
      amountTransactionMoney: '',
      // varaibles para la transaccion entre cuentas

      accountOut: '',
      accountIn: '',
      amountOut: 0,
      amountIn: 0,
      amountAccountTransact: '',
      amountAccountTransactNumber: 0,
      amountOutAfter: '0',
      amountInAfter: '0',
      amountAccountTransactBool: true,
      isLoadingAccounts: false,

      mask_quetzal: createNumberMask({
        prefix: 'Q ',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false
      }),
      pagination: {
        'total': 0,
        'current_page': 0,
        'per_page': 0,
        'last_page': 0,
        'from': 0,
        'to': 0
      },
      offset: 3,
      critery: 'description',
      search: '',
      transactionState: false
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + (this.offset * 2)
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    this.fetchData(1, this.search, this.critery, this.transactionState)
    // this.formatQuetzales()
  },
  install (Vue, options) {
    Vue.component('SweetModal', SweetModal)
    Vue.component('SweetModalTab', SweetModalTab)
  },
  validations () {
    if (this.typeAction === 1) {
      if (this.typeTransaction == 0) {
        return {
          amountTransaction: {
            required,
            maxValue: maxValue(this.amountMoney),
            minValue: minValue(1)
          },
          description: {
            required
          },
          amount: {
            required
          },
          document_number: {
          },
          typeTransaction: {
            required
          },
          payment: {
            required
          },
          accountIn: {
          },
          accountOut: {
          },
          amountAccountTransactNumber: {
          }
        }
      } else {
        return {
          amountTransaction: {
            required,
            minValue: minValue(1)
          },
          description: {
            required
          },
          amount: {
            required
          },
          document_number: {

          },
          typeTransaction: {
            required
          },
          payment: {
            required
          },
          accountIn: {

          },
          accountOut: {
          },
          amountAccountTransactNumber: {
          }
        }
      }
    } else {
      return {
        accountOut: {
          required
          // sameAsNothing: sameAs('nothing')
        },
        accountIn: {
          required,
          isNotsameAsAccountOut: not(sameAs('accountOut'))
        },
        amountAccountTransactNumber: {
          required,
          maxValue: maxValue(this.converMaskToNumber(this.amountOut)),
          minValue: minValue(1)
          // sameAsNothing: sameAs('nothing')
        },
        amountTransaction: {
        },
        description: {
        },
        amount: {
        },
        document_number: {
        },
        typeTransaction: {
        },
        payment: {
        }
      }
    }
  },
  methods: {
    changePage (page, search, critery, state) {
      let me = this
      // Actualiza la página actual
      me.pagination.current_page = page
      // Envia la petición para visualizar la data de esa página
      me.fetchData(page, search, critery, state)
    },
    async fetchData (page, search, critery, state) {
      let me = this
      const response = await axios.get(`/api/admin/detailTransaction/get?page=${page}&search=${search}&critery=${critery}&state=${state}`)
      // console.log(response.data.data)
        .then(function (response) {
          var respuesta = response.data
          me.transactionsArray = respuesta.transactions.data
          me.pagination = respuesta.pagination
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    saveTransact () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      let operacion = 0
      this.convercionesMoney()
      // this.amount = this.converMaskToNumber(this.amount)
      if (this.typeTransaction == 1) {
        operacion = parseFloat(me.amountMoney) + parseFloat(me.amountTransaction)
        // console.log(operacion)
      } else {
        operacion = parseFloat(me.amountMoney) - parseFloat(me.amountTransaction)
        // console.log(operacion)
      }
      // console.log(operacion)
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        var data = new FormData()
        data.append('description', this.description)
        data.append('document_number', this.document_number)
        data.append('amount', this.amountTransaction)
        data.append('typeTransaction', this.typeTransaction)
        data.append('idtransaction', this.idaccount.id)
        data.append('amountAccount', operacion)
        data.append('photo', this.photo)
        data.append('idpayment', this.payment)
        axios.post('/api/admin/detailTransaction', data)
          .then(function (response) {
            toastr.success(response.data.message, 'Listo')
            l.stop()
            me.closeModal()
          })
          .catch(function (error) {
            l.stop()
            console.log(error)
            toastr.error(error.response.data.message, 'Error')
          })
      }
    },
    cancelTransact () {
      // console.log(this.idaccount)
      let me = this
      let operacion = 0
      if (me.typeTransaction == 1) {
        operacion = parseFloat(me.amountAccount) - parseFloat(me.amount)
        // console.log(typeof (me.amountAccount) + typeof (me.amount))
        if (me.amount > me.amountAccount) {
          toastr.error('No puede cancelar este deposito, no tiene dinero suficiente en la cuenta.', 'Error')
          me.closeModal()
        } else {
          axios.patch('/api/admin/detailTransaction/cancel', {
            id: me.id,
            idtransaction: me.idaccount,
            newamount: operacion
          })
            .then(function (response) {
              toastr.success(response.data.message, 'Listo')
              me.closeModal()
              // Aqui volver a listar todo
            })
            .catch(function (error) {
              toastr.error(error.response.data.message, 'Error')
            })
        }
      } else {
        operacion = parseFloat(me.amountAccount) + parseFloat(me.amount)
        axios.patch('/api/admin/detailTransaction/cancel', {
          id: me.id,
          idtransaction: me.idaccount,
          newamount: operacion
        })
          .then(function (response) {
            toastr.success(response.data.message, 'Listo')
            me.closeModal()
            // Aqui volver a listar todo
          })
          .catch(function (error) {
            toastr.error(error.response.data.message, 'Error')
          })
      }
    },
    saveTransactAccounts () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        // var data = new FormData()
        // data.append('accountOut', this.accountOut)
        // data.append('accountIn', this.accountIn)
        // data.append('amount', this.amountAccountTransactNumber)
        axios.post('/api/admin/detailTransaction/accountsTrade', {
          accountOut: this.accountOut,
          accountIn: this.accountIn,
          amount: this.amountAccountTransactNumber
        })
          .then(function (response) {
            toastr.success(response.data.message, 'Listo')
            l.stop()
            me.closeModal()
          })
          .catch(function (error) {
            l.stop()
            console.log(error)
            toastr.error(error.response.data.message, 'Error')
          })
        // console.log('hola')
      }
    },
    openModal (accion, data = []) {
      let me = this
      switch (accion) {
        case 'register':
        {
          me.$refs.modal_transact.open()
          this.modalTitle = 'Nueva transacción'
          this.description = ''
          this.document_number = ''
          this.amountTransaction = ''
          this.typeAction = 1
          this.selectAccount('A')
          break
        }
        case 'cancel':
        {
          me.$refs.activate_modal.open()
          this.modalTitleActivate = '¿Desea cancelar la transacción?'
          this.id = data['id']
          this.amount = data['amount']
          this.amountAccount = data['account']['amount']
          this.typeTransaction = data['type_transaction']
          this.idaccount = data['idtransactions']
          this.typeAction = 2
          break
        }
        case 'accounts':
        {
          this.typeAction = 0
          me.$refs.accountsModal.open()
          this.modalTitle = 'Transacción entre cuentas'
          this.selectAccount('A')
          break
        }
        case 'photo':
        {
          this.$refs.photoModal.open()
          this.photoTrans = '/transactions/' + data
        }
      }
    },
    closeModal () {
      this.$v.$reset()
      this.$refs.modal_transact.close()
      this.$refs.activate_modal.close()
      this.$refs.accountsModal.close()
      this.modalTitleActivate = ''
      this.description = ''
      this.document_number = ''
      this.amountTransaction = ''
      this.idplace = 0
      this.id = 0
      this.amount = 0
      this.amountAccount = 0
      this.type_transaction = ''
      this.idaccount = 0
      this.amountTransactionMoney = ''
      this.typeTransaction = null
      this.payment = ''
      this.accountOut = ''
      this.accountIn = ''
      this.amountOut = 0
      this.amountIn = 0
      this.amountAccountTransact = ''
      this.amountAccountTransactNumber = 0
      this.amountAccountTransactBool = true
      this.amountTransactionBool = true
      this.fetchData(this.pagination.current_page, this.search, this.critery, this.transactionState)
    },
    selectAccount (filter) {
      let me = this
      var url = `/api/admin/account/getSelect?filter=${filter}`
      this.isLoadingAccounts = true
      axios.get(url).then(function (response) {
        me.accountArray = response.data.data
        me.isLoadingAccounts = false
      })
        .catch(function (error) {
          console.log(error)
          me.isLoadingAccounts = false
        })
    },
    llamarAmount () {
      this.amount = this.idaccount.amount
      this.paymentsArray = this.idaccount.payments
      this.convercionesMoney()
      this.formatQuetzales()
      this.amountTransactionBool = false
    },
    llamarAmountOut () {
      if (this.accountOut === null) {
        this.amountOut = '0'
      } else {
        this.amountOut = this.formatQuetzales2(this.accountOut.amount)
        this.amountAccountTransactBool = false
      }
    },
    llamarAmountIn () {
      if (this.accountIn === null) {
        this.amountIn = '0'
      } else {
        this.amountIn = this.formatQuetzales2(this.accountIn.amount)
      }
    },
    converMaskToNumber (number) {
      var myNumber = ''
      for (var i = 0; i < number.length; i += 1) {
        if (number.charAt(i) === 'Q' || number.charAt(i) === ',' || number.charAt(i) === ' ') {
          continue
        } else {
          myNumber += number.charAt(i)
        }
      }
      // console.log(myNumber)
      return parseFloat(myNumber).toFixed(2)
    },
    formatQuetzales () {
      var num = parseFloat(this.amount), formatted
      formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      this.amount = 'Q ' + formatted
    },
    formatQuetzales2 (amount) {
      if (isNaN(amount)) {
        return amount
      } else {
        var num = parseFloat(amount), formatted
        formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        return amount = 'Q ' + formatted
      }
    },
    formatQuetzales3 (amount) {
      var num = parseFloat(amount), formatted
      formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      return amount = 'Q ' + formatted
    },
    convercionesMoney () {
      this.amountMoney = this.converMaskToNumber(this.amount)
    },
    convertTrans () {
      this.amountTransaction = this.converMaskToNumber(this.amountTransactionMoney)
    },
    getImage (event) {
      this.photo = event.target.files[0]
    },
    convertamountTransact () {
      this.amountAccountTransactNumber = this.converMaskToNumber(this.amountAccountTransact)
    }
  }
}
</script>
<style>
.error {
  color: #dc3545;
}
.imgRedondo {
  width: 540px !important;
  height: 480px !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/admin/account/Transaction.vue